import URL_ROUTE from '../constants/index';

// El token se lee en cada llamada (no al cargar el módulo) para usar siempre el de la sesión actual
const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
})

class ApiNotificaciones {

    async listarNotificaciones(limite = 50) {
        const query = await fetch(`${URL_ROUTE.LISTARNOTIFICACIONES}`, {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({ limite })
        });
        return query;
    }

    async marcarNotificacionLeida(id_notificacion) {
        const query = await fetch(`${URL_ROUTE.MARCARNOTIFICACIONLEIDA}`, {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({ id_notificacion })
        });
        return query;
    }

    async marcarTodasLeidas() {
        const query = await fetch(`${URL_ROUTE.MARCARTODASNOTIFICACIONESLEIDAS}`, {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({})
        });
        return query;
    }
}

export default new ApiNotificaciones();
